import { render, staticRenderFns } from "./GatePage.vue?vue&type=template&id=63a40aa9&scoped=true&"
import script from "./GatePage.vue?vue&type=script&lang=js&"
export * from "./GatePage.vue?vue&type=script&lang=js&"
import style0 from "./GatePage.vue?vue&type=style&index=0&id=63a40aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a40aa9",
  null
  
)

export default component.exports